module.exports = __webpack_public_path__ + "static/ziggy_hero-3e2813ce792a55292e491340b24d29c9.png";